<template>
  <div class="actionLog">
    <div class="section">
      <div class="search">
        <div class="search-title" style="border-left: 1px solid #738089;">
          <span>{{ $t('protocol.pn') }}：</span>
          <el-input v-model="search.pn" clearable></el-input>
        </div>
        <div class="search-title">
          <span>{{ $t('protocol.postal_address') }}：</span>
          <el-input v-model="search.devaddr" clearable></el-input>
        </div>
        <div class="search-title">
          <span>{{ $t('protocol.Protocol_encoding') }}：</span>
          <el-input v-model="search.devcode" clearable></el-input>
        </div>
        <div class="search-title">
          <span>{{ $t('protocol.date') }}：</span>
          <el-date-picker
            :editable="false"
            clearable
            type="date"
            v-model="search.date"
            :picker-options="pickerrangeOptions"
            :placeholder="$t('protocol.Please_date')"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            ref="dateDay"
            popper-class="select-date1"
          ></el-date-picker>
        </div>
        <el-button class="button button-solid" @click.stop="getData">
          <i class="el-icon-search"></i>
        </el-button>
      </div>
      <el-table
        class="tablemain tableloding"
        v-loading="isLoading"
        element-loading-spinner="el-icon-loading"
        height="100%"
        stripe
        border
        :data="dataCode"
        :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }"
        :empty-text="$t('account.nodata')"
      >
        <el-table-column
          width="130px"
          type="index"
          :label="$t('actionLog.index')"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          prop="gts"
          :label="$t('protocol.Protocol_instructions')"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="usr"
          :label="$t('protocol.Query_Results')"
          :show-overflow-tooltip="false"
        ></el-table-column>
        <el-table-column
          fixed="right"
          :label="this.$t('device.Operation')"
          width="220px"
          class="fixedRgiht"
        >
          <template slot-scope="scope">
            <!-- 查询 -->
            <el-button
              type="text"
              class="operation"
              @click="queryClick(scope.row,scope.$index)"
            >{{ $t('protocol.query') }}</el-button>
            <!-- CRC校验 -->
            <el-button
              type="text"
              class="operation"
              @click="CRCcheckClick(scope.row)"
            >{{ $t('protocol.CRC_verification') }}</el-button>
            <!-- 长度校验 -->
            <el-button
              type="text"
              class="operation"
              @click="lengthVerification(scope.row,scope.$index)"
            >{{ $t('protocol.Length_verification') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="tablebottom">
        <div class="search">
          <div class="search-title">
            <span>{{ $t('protocol.Data_index') }}：</span>
            <el-input type="number" v-model="search.index"></el-input>
          </div>
          <div class="search-title">
            <span>{{ $t('protocol.raw_data') }}：</span>
            <el-input v-model="search.repdat"></el-input>
          </div>
          <!-- 解析 -->
          <el-button
            class="button button-solid"
            @click.stop="analysisClick"
          >{{ $t('rawData.analysis') }}</el-button>
        </div>
      </div>
      <!-- CRC校验 -->
      <account-dialog
        :title="$t('protocol.CRC_verification')"
        :visible.sync="showDeletecountDialog"
        :width="'450px'"
        :class="{ 'showDialog': showDeletecountDialog, 'hideDialog': !showDeletecountDialog }"
        noFooter
      >
        <div class="content_tishi" slot="content">
          <div class="tital">
            <span class="contentdelete" style="width:100%;text-align:left;">
              <span style="color: rgba(255,204,102);">{{ $t('protocol.verification_results') }}:</span>
              {{ CRCFlag ? $t('protocol.agreement'):$t('protocol.atypism') }}
            </span>
          </div>
        </div>
      </account-dialog>
      <!-- 长度校验 -->
      <account-dialog
        :title="$t('protocol.Length_verification') "
        :visible.sync="amendManufacturerCodetDialog"
        :width="'450px'"
        :class="{ 'showDialog': amendManufacturerCodetDialog, 'hideDialog': !amendManufacturerCodetDialog }"
        noFooter
      >
        <div class="content_tishi" slot="content">
          <div class="tital">
            <span class="contentdelete" style="width:100%;text-align:left;">
              <span style="color: rgba(255,204,102);">{{ $t('protocol.verification_result') }}:</span>
              {{ CRCFlag ? $t('protocol.agreement'):$t('protocol.atypism') }}
            </span>
          </div>
        </div>
      </account-dialog>
      <!-- 解析结果 -->
      <account-dialog
        :title="$t('protocol.Analysis_results')"
        :visible.sync="amendfacturerCodetDialog"
        :width="'450px'"
        :class="{ 'showDialog': amendfacturerCodetDialog, 'hideDialog': !amendfacturerCodetDialog }"
        noFooter
      >
        <div class="content_tishi" slot="content">
          <div class="tital" v-for="(item,index) in analysisData" :key="index">
            <span>name：{{ item.name }}</span>
            <span style="margin: 0 27px;">raw：{{ item.raw }}</span>
            <span>dat：{{ item.val }}</span>
          </div>
        </div>
      </account-dialog>
    </div>
  </div>
</template><script>
import accountDialog from "@/components/dialognew";
export default {
  components: {
    accountDialog
  },
  data() {
    return {
      emptyText: false,
      paginationControl: false,
      showDeletecountDialog: false,
      amendManufacturerCodetDialog: false,
      amendfacturerCodetDialog: false,
      isLoading: false,
      CRCFlag: Boolean,
      dataCode: [],
      analysisData: [],
      search: {
        pn: "",
        devaddr: "1",
        devcode: "",
        date: new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + (new Date().getDate()),
        index: "",
        repdat: ""
      },
      searchActionInput: "",
      searchActionSelect: "",
      selection: [],
      pickerrangeOptions: {
        disabledDate: time => {
          return (
            time.getTime() >
            new Date(
              new Date(new Date().toLocaleDateString()).getTime() +
                24 * 60 * 60 * 1000 -
                1
            )
          );
        }
      }
    };
  },
  mounted() {},
  methods: {
    // 列表数据
    getData(reset) {
      this.paginationControl = false;
      this.isLoading = true;
      this.dataCode = [];
      let params = {
        pn: this.search.pn,
        devaddr: this.search.devaddr,
        devcode: this.search.devcode,
        date: this.search.date,
        i18n: this.$lang.currentLang
      };
      this.$request.get("adminQueryProtocolCmds", params).then(res => {
        if (res.err == 0) {
          if (res.dat) {
            res.dat.forEach(item => {
              this.dataCode.push({
                gts: item
              });
            });
          }
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
        this.isLoading = false;
      });
    },
    // 查询
    queryClick(row, index) {
      let params = {
        pn: this.search.pn,
        devaddr: this.search.devaddr,
        cmd: row.gts,
        i18n: this.$lang.currentLang
      };
      this.$request.get("adminSendCmdToDevice", params).then(res => {
        if (res.err == 0) {
          this.$set(this.dataCode[index], "usr", res.dat);
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
      });
    },
    // CRC校验
    CRCcheckClick(row) {
      let params = {
        devcode: this.search.devcode,
        repdat: row.usr,
        i18n: this.$lang.currentLang
      };
      if (row.usr) {
        this.$request.get("adminDeviceDatCrcCheck", params).then(res => {
          if (res.err == 0) {
            this.showDeletecountDialog = true;
            this.CRCFlag = res.dat;
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
      } else {
        this.$message.error(this.$t("protocol.Please_results"));
      }
    },
    // 长度校验
    lengthVerification(row, index) {
      let params = {
        devcode: this.search.devcode,
        repdat: row.usr,
        senddat: row.gts,
        index: index + 1,
        i18n: this.$lang.currentLang
      };
      if (row.usr) {
        this.$request.get("adminDeviceDatLengthCheck", params).then(res => {
          if (res.err == 0) {
            this.amendManufacturerCodetDialog = true;
            this.CRCFlag = res.dat;
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
      } else {
        this.$message.error(this.$t("protocol.Please_results"));
      }
    },
    // 解析
    analysisClick() {
      let params = {
        index: this.search.index,
        repdat: this.search.repdat,
        devcode: this.search.devcode,
        i18n: this.$lang.currentLang
      };
      this.$request.get("adminDeviceSegDatParse", params).then(res => {
        if (res.err == 0) {
          this.analysisData = res.dat;
          this.amendfacturerCodetDialog = true;
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
      });
    }
  }
};
</script>
  <style lang="less" scoped>
@import url("../../../../assets/css/mixin.less");

.actionLog {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: auto;
  margin: 20px;

  .button {
    height: 48px;
    line-height: 48px;
    padding: 0 25px;
    margin-top: 0px;
    color: @primaryTextColor;
    background: transparent;
    border: none;
  }

  // margin: 24px 24px 50px 24px;
  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  .search {
    margin: 0px;
    align-self: flex-end;
    padding: 0px 0px 0 10px;
  }

  .section {
    // padding-bottom: 10px;
    flex: 1;
    display: flex;
    border-radius: 0px;
    border: none;
    flex-direction: column;
    background: rgb(34, 45, 53);
    padding: 0px;
    overflow: hidden;

    // .list-header {
    //   .title {
    //    font-size:16px;
    //    font-weight: bold;
    //    color: #333;
    //    letter-spacing: 1.5px;
    //     // .sc(24px, #333);
    //   }
    // }
    /deep/.el-icon-loading {
      font-size: 28px;
    }

    .tableloding {
      // 加载数据时遮罩
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, 0.5);
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }

    .tablemain {
      border: none;
      background-color: rgb(34, 45, 53);

      .operation {
        // color: @primaryTextColor;
        color: #fff;
      }

      /deep/.el-table--border::after,
      /deep/.el-table--group::after {
        width: 0px;
      }

      /deep/.el-table__header th {
        height: 48px;
      }

      /deep/.el-table__header th.is-leaf {
        border-color: rgba(198, 209, 221, 0.5);
        border-bottom: none;
      }

      /deep/.el-table__header th > .cell {
        font-weight: normal;
        font-size: 12px;
      }

      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        background-color: rgb(34, 45, 53);
        color: #ffffff;
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__body td.el-table-column--selection {
        background-color: rgb(65, 80, 90);
        color: #ffffff;
      }

      /deep/.el-table__body .cell.el-tooltip {
        font-size: 14px;
      }

      /deep/.el-table__fixed-right::before,
      /deep/.el-table__fixed::before {
        display: none;
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #222d35;
      }

      // 关于头部右侧空白
      /deep/.el-table__fixed-right-patch {
        background-color: rgb(65, 80, 90);
        border-bottom: none;
      }

      /deep/th.gutter {
        background-color: rgb(65, 80, 90);
      }
    }

    .tablebottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid rgba(198, 209, 221, 0.5);

      // 分页
      .pagination {
        line-height: 48px;
        height: 48px;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 16px;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202d35;
          color: #ffffff;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7b8395;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pager li:not(.disabled).active {
          // background: #15C491;
          // color: #ffffff;
          background-color: #2b3842;
          color: #15c491;
        }

        // li:not(.disabled):not(.active):hover
        /deep/.el-pager li:not(.disabled):hover {
          background-color: @primaryColorTransparency30;
          color: rgba(255, 255, 255, 1);
        }

        /deep/.el-pager li {
          background-color: #2b3842;
          color: #7b8395;
        }

        // 页条数下拉
        /deep/.el-select .el-input .el-input__inner {
          border: none;
          height: 48px;
          line-height: 48px;
          border-radius: 0px;
        }

        /deep/.el-select .el-input .el-input__inner:hover {
          background: @primaryColorTransparency30;
        }

        // 跳页
        /deep/.el-pagination__jump {
          color: #ffffff;
        }

        /deep/.el-pagination__editor {
          padding: 0px 6px;
        }

        /deep/.el-pagination__editor.el-input .el-input__inner {
          border: 1px solid #7b8395;
        }
      }

      // 分页前后按钮
      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2b3842;
        color: #7b8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        background-color: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        background-color: #2b3842;
        color: #7b8395;
      }
    }
  }

  /deep/.el-icon-date:before {
    content: "";
    display: inline-block;
    position: absolute;
    top: 6px;
    right: 140px;
    height: 24px;
    width: 24px;
    // background: url(../../../../assets/img/general/Icon_Calendar.png) no-repeat;
    background-size: 100%;
    background-position: center;
  }

  /deep/.el-date-editor .el-range-input {
    color: #fff;
    background-color: #222d35;
    width: 160px;
    line-height: 36px !important;
    height: 36px !important;
  }
}
</style>
  <style lang="less">
/deep/.el-range__icon {
  margin-left: 25px;
}

/deep/.el-date-editor--daterange {
  color: #fff;
  background-color: #2b3842;
}

.el-date-editor .el-range-separator {
  color: #fff !important;
  width: 18%;
  line-height: 36px;
}

.select-date1.el-picker-panel {
  background-color: #222d35;
  border: none;
  padding-top: 10px;

  .el-picker-panel__body-wrapper {
    .el-picker-panel__body {
      border: #222d35;
    }

    .el-picker-panel__sidebar {
      width: 100%;
      position: relative;
      padding: 0px;
      background: transparent;
      color: #ffffff;
      border: none;

      .el-picker-panel__shortcut,
      .el-picker-panel__shortcut:hover {
        padding-left: 0px;
        padding-bottom: 20px;
        color: @primaryTextColor;
        text-align: center;
      }
    }
  }

  .el-date-range-picker__header {
    color: #fff;
  }

  .in-range {
    background-color: #222d35;
  }

  .el-picker-panel__shortcut:hover {
    padding-left: 0px;
    padding-bottom: 20px;
    color: @primaryTextColor;
    text-align: center;
  }

  .el-date-table td.today span {
    color: @primaryTextColor;
    font-weight: 700;
  }

  .el-date-table td.in-range div {
    background-color: rgba(48, 208, 150, 0.7);
  }

  .el-picker-panel__icon-btn {
    color: rgba(48, 208, 150);
    font-size: 14px;
    font-weight: bold;
  }

  .el-date-table td.end-date span,
  .el-date-table td.start-date span {
    color: #fff;
    background-color: @primaryTextColor;
    border: @primaryTextColor;
  }

  .el-date-table td.in-range {
    background-color: #222d35;
  }

  .el-date-table td:hover {
    color: rgba(48, 208, 150);
  }

  .el-date-table td.next-month,
  .el-date-table td.prev-month {
    color: #606266;
  }

  .el-date-table td {
    color: #fff;
  }

  .el-date-table td.disabled div {
    background-color: #222d35 !important;
    color: #606266 !important;
  }
}

.actionLog {
  .search {
    display: flex;

    // #下拉选框#
    .select-search-recharge {
      background-color: rgb(34, 45, 53);
      box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
      border-radius: 4px;
      border: none;
      padding: 8px 0px;

      .el-select-dropdown__list {
        padding: 0px;
      }

      .el-select-dropdown__item {
        padding: 0px 16px;
        font-size: 14px;
        height: 32px;
        line-height: 32px;
        color: rgba(255, 255, 255, 1);
      }

      .el-select-dropdown__item.hover {
        padding: 0px 16px;
        background-color: transparent;
        font-weight: normal;
      }

      .el-select-dropdown__item.selected {
        padding: 0px 16px;
        background-color: transparent;
        font-weight: normal;
        color: rgba(255, 255, 255, 1);
      }

      .el-select-dropdown__item:hover {
        padding: 0px 16px;
        background: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      .el-select-dropdown__item.selected .select-label {
        padding: 0px;
      }

      // 对号
      .el-select-dropdown__item.selected:before,
      .el-select-dropdown__item.selected .select-label:before,
      .el-select-dropdown__item.selected.choose-num:before {
        content: "";
        display: inline-block;
        height: 16px;
        width: 16px;
        background: url(../../../../assets/img/general/Icon_Duihao.png);
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
        position: absolute;
        top: 8px;
        right: 16px;
      }
    }

    .select-search-project {
      .el-select-dropdown__list {
        padding: 0 16px;
      }

      .el-select-dropdown__item {
        height: 40px;
        line-height: 40px;
        box-shadow: 0px 0.5px rgba(198, 209, 221, 0.2);
      }
    }

    .selectClearNew {
      // 下拉选中清除按钮
      .el-icon-circle-close:before {
        content: "";
        display: inline-block;
        height: 16px;
        width: 16px;
        background: url(../../../../assets/img/general/Icon_SelectClear.png);
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
        // position: absolute;
        // top: 8px;
        // right: 16px;
      }
    }

    .search-title {
      color: #fff;
      padding: 5px;
    }

    .el-select,
    .el-input {
      width: 165px;
      border-right: 1px solid #738089;
    }

    .el-input__inner {
      background: transparent;
      border: none;
      height: 36px;
      line-height: 36px;
      color: #ffffff;
      padding: 0 16px;
    }
  }

  .upload-button {
    width: 100%;
  }
}
</style>